module.exports = "/_next/static/images/84d7b98ff7f43eca405a4bc874b799c2-double-card@md-1x.png";